import React, { useState } from 'react';
import classNames from 'classnames';
import 'Components/Modals/PaymentModal/index.css';
import {
  FDBanner, FDBannerSecondary, FDBannerText, FDSecondaryActionButton,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { dataAttrs } from 'Helpers/Testing';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';

const useStyles = buildUseStyles('CompleteActionItemBanner', ((theme) => ({
  sticky: {
    position: 'sticky',
    zIndex: theme.zIndex.appBar,
  },
  stickyDesktop: {
    // Show this just under the navbar
    top: theme.heights.desktopTopNavigationHeight,
  },
})));

export const Banner = ({
  label, onChange, btnText, beforeCompletion,
}) => {
  const [loading, setLoading] = useState(false);
  const { displayErrorMessage } = useSnackbarContext();
  const classes = useStyles();
  const isMobile = useMobileLayout();

  return (
    <div className={classNames(classes.sticky, { [classes.stickyDesktop]: !isMobile })}>
      <FDBanner color="attention">
        <FDBannerText value={label} />
        <FDBannerSecondary>
          <FDSecondaryActionButton
            label={btnText}
            loading={loading}
            onClick={async () => {
              setLoading(true);
              try {
                await beforeCompletion();
              } catch (err) {
                displayErrorMessage(err, 'Error completing');
                setLoading(false);
                return;
              }
              setLoading(false);
              onChange(true);
            }}
            size="sm"
            {...dataAttrs('action-item-complete-btn')}
          />
        </FDBannerSecondary>
      </FDBanner>
    </div>
  );
};

Banner.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  btnText: PropTypes.string.isRequired,
  beforeCompletion: PropTypes.func.isRequired,
};
Banner.defaultProps = {
};
